<div>
  <app-wysiwyg-editor
    #editor
    (editorContentEvent)="emitAutosave($event)"
    [version]="'none'"
    [config]="config"
    [editorContent]="initialContent"
    [isSaving]="isSaving" />
</div>
